
// ===========================================================================
class TimedCallback {
    constructor( parameter, deltaTime, callback ) {
        this.parameter     = parameter;
        this.deltaTime     = deltaTime;
        this.callback      = callback;
        this.internalTimer = null;
    }

    start() {
        this.startWith( this.deltaTime );
    }

    startWith( deltaTime ) {
        this.stop();
        this.internalTimer = setTimeout(
            () => { this.callback( this.parameter ); }
            ,deltaTime
        );
    }

    stop() {
        if( this.internalTimer != null ) {
            clearTimeout( this.internalTimer );
            this.internalTimer = null;
        }
    }
}

class TimedSequence {
    constructor() {
        this.timedCallbacks = [];
    }

    add( parameters, deltaTime, callback ) {
        this.timedCallbacks.push( new TimedCallback( parameters, deltaTime, callback ) );
    }

    addAbsolute( parameters, absoluteTime, callback ) {
        // -- Find insertion point. --
        let cumulateTime = 0;
        let cursor;
        let newArray = [];
        let length = this.timedCallbacks.length;
        for( cursor = 0; cursor < length; ++cursor ) {
            let timedAction = this.timedCallbacks[ cursor ];
            let tmp = cumulateTime + timedAction.deltaTime;
            if (tmp > absoluteTime) break;
            newArray.push( timedAction );
            cumulateTime = tmp;
        }

        // -- Add new timed callback --
        let deltaTime = absoluteTime - cumulateTime;
        newArray.push( new TimedCallback( parameters, deltaTime, callback ) );

        // -- Adjust the delta time of the subsequent callback. --
        if( cursor < length ) {
            let toAdjust = this.timedCallbacks[ cursor ];
            toAdjust.deltaTime -= deltaTime;
            newArray.push( toAdjust );
            ++cursor;
        }

        // -- Insert all remaining timed callback in the new array. --
        for( ; cursor < length; ++ cursor ) {
            newArray.push( this.timedCallbacks[ cursor ] );
        }
        this.timedCallbacks = newArray;
    }

    start() {
        let cumulatedDeltaTime = 0;
        this.timedCallbacks.forEach(
            (timedCallback) => {
                timedCallback.startWith( cumulatedDeltaTime + timedCallback.deltaTime );
                cumulatedDeltaTime += timedCallback.deltaTime;
            }
        );
    }

    stop() {
        this.timedCallbacks.forEach( (timedCallback) => { timedCallback.stop(); } );
    }
}

// -- Exporting the main class of the module for usage in a client (browser). --
var gExports = {
    TimedSequence: TimedSequence
};

window.Sequencer = gExports;